<style>
.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted;
}
</style>
<template>
<div id="page-usuarios" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Configurables" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>
                                <template slot="nombre" slot-scope="props" >
                                    <span>{{ props.row.nombre }}</span>
                                </template>

                                <template slot="nombre" slot-scope="props" >
                                    <div @click="openModalDetalle(props.row.id)" :class="['showPerfil']" >
                                        {{props.row.prefijo}}_{{ props.row.nombre }}
                                    </div>                                    
                                </template>
                                
                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-model="fab[props.row.id]" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon v-if="fab[props.row.id]" >mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn x-small fab dark color="blue" @click.native="getConfigurable(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>                                                                                
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal" width="45%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal = false" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>{{ update ? "Actualizar" : "Nuevo" }} Configurable</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs11>
                                <v-autocomplete :items="tipos" v-model="model.tipo" 
                                    :item-text="getNombreTipo" item-value="tipo" label="Tipo de Configurable" 
                                    :rules="[rules.required]" @change="clearOpciones()" ></v-autocomplete>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" maxlength="250" ></v-text-field>
                            </v-flex>
                        </v-layout>
                        
                        <v-layout wrap>
                            <v-flex xs11 v-if="model.tipo=='Expediente'" >
                                <v-select clearable :items="tiposOperacion" v-model="opciones.tipo_operacion" 
                                    item-text="nombre" item-value="tipo" label="Tipo de Operación" ></v-select>
                            </v-flex>                        
                            <v-flex xs11 v-if="model.tipo=='Expediente'" >
                                <v-autocomplete clearable :hide-no-data="true" :items="clavesPedimentos" v-model="opciones.clave_pedimento" 
                                    multiple item-text="clave" item-value="clave" label="Clave de Pedimento" ></v-autocomplete>
                            </v-flex>                        
                            <v-flex xs11>
                                <v-autocomplete clearable :hide-no-data="true" :items="patentesArr" v-model="opciones.patente" multiple
                                     label="Patente" ></v-autocomplete>
                            </v-flex>                        
                            <v-flex xs11>
                                <v-autocomplete clearable :hide-no-data="true" :items="aduanasArr" v-model="opciones.aduana" multiple
                                    item-text="nombre" item-value="clave" label="Aduana" ></v-autocomplete>
                            </v-flex>  
                            <!-- Lourdes solicito quitar estos 2 datos -->                      
                            <!--v-flex xs11 v-if="model.tipo=='AgenciaAduanal'" >
                                <v-autocomplete clearable :hide-no-data="true" :items="usuariosArr" v-model="opciones.usuario" 
                                    item-text="nombre" item-value="clave" label="Usuario" ></v-autocomplete>
                            </v-flex>
                            <v-flex xs11 v-if="model.tipo=='AgenciaAduanal'" >
                                <v-autocomplete clearable :hide-no-data="true" :items="metadatosArr" v-model="opciones.metadato" 
                                    item-text="nombre" item-value="tipo" label="Metadato" ></v-autocomplete>
                            </v-flex-->
                        </v-layout>   
                        <v-layout wrap>
                            <v-flex xs12>
                                Seleccione los Tipos de Documentos {{"("+opciones.tipos_documento.length + " seleccionados)"}}
                            </v-flex>
                        </v-layout>
                        <v-client-table ref="vuetabletipos" :data="tiposDocumentos.items" :columns="tiposDocumentos.columns" :options="tiposDocumentos.options" class="elevation-2 pa-2 scroll-table" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >Cargando...</v-alert>
                            </template>

                            <div slot="filter__id" >
                                <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()" >
                            </div>
                            <template slot="id" slot-scope="props" >
                                <div style="display:flex; justify-content:center;" >
                                <input :id="props.row.id+'-'+props.row.clave" type="checkbox" v-model="opciones.tipos_documento" :value="props.row.clave+''" ></input>
                                </div>
                            </template>
                        </v-client-table>                                                               
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="update ? updateConfigurable() : save()" >
                    <v-icon>done</v-icon> {{ update ? "Actualizar" : "Guardar" }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_detalle" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_detalle = false" class="white--text" >cancel</v-icon>
                    <span class="subheading" >
                        <strong>{{ titleModalDetalle }}</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <span class="negrita" >Tipo de Configurable:</span> {{getTipo(model.tipo)}} ({{model.prefijo}})
                            </v-flex>
                            <v-flex xs12>
                                <span class="negrita" >Nombre:</span> {{model.prefijo}}_{{model.nombre}}                                
                            </v-flex>
                        </v-layout>
                        
                        <v-layout wrap>
                            <v-flex xs12 v-if="model.tipo=='Expediente'" >
                                <span class="negrita" >Tipo de Operación:</span> {{opciones.tipo_operacion}}                                
                            </v-flex>                        
                            <v-flex xs12 v-if="model.tipo=='Expediente'" >
                                <span class="negrita" >Clave de Pedimento:</span> {{opciones.clave_pedimento}}                                
                            </v-flex>                        
                            <v-flex xs12>
                                <span class="negrita" >Patente:</span> {{opciones.patente}}                                
                            </v-flex>                        
                            <v-flex xs12>
                                <span class="negrita" >Aduana:</span> {{opciones.aduana}}                                
                            </v-flex>                        
                            <!-- Lourdes solicitó quitar estos 2 datos -->
                            <!--v-flex xs12 v-if="model.tipo=='AgenciaAduanal'" >
                                <span class="negrita" >Usuario:</span> {{opciones.usuario}}                                
                            </v-flex>
                            <v-flex xs12 v-if="model.tipo=='AgenciaAduanal'" >
                                <span class="negrita" >Metadato:</span> {{opciones.metadato}}                                
                            </v-flex-->  
                        </v-layout>                           
                        <v-client-table ref="vuetabletiposfiltrados" :data="tiposDocumentos.filtrados" 
                            :columns="tiposDocumentos.columnsFiltrados" :options="tiposDocumentos.optionsFiltrados" class="elevation-2 pa-2 scroll-table" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontraron resultados...</v-alert>
                            </template>
                        </v-client-table>                                                               
                    </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_detalle = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>                
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {    
    data() {
        return {            
            id_cliente:"",   
            fab: [],      
            allChecked: false,
            columns: [
                "tipo",
                "nombre",
                "created_at",
                "usuario",                
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["tipo","nombre","created_at","usuario"],
                sortable: ["tipo","nombre","created_at","usuario"],
                headings: {
                    tipo:"Tipo",
                    nombre: "Nombre del Configurable",
                    created_at: "Fecha Creado",
                    usuario: "Usuario",                    
                    actions: "Operaciones"
                },                
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    href: "/admin"
                },
                {
                    text: "Configurables",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            titleModalDetalle: "",            
            modal: false,
            modal_detalle: false,            
            update: false,
            clavesPedimentos: [],
            patentesArr:[],
            aduanasArr:[],
            usuariosArr:[],
            metadatosArr:[],
            tipos:[{
                    tipo: "Expediente",
                    nombre: "CheckList EEA",
                    prefijo: "CL",
                },
                /* {
                    tipo: "AgenciaAduanal",
                    nombre: "CheckList Agencia Aduanal",
                    prefijo: "CLAA",
                } */
            ],
            tiposOperacion:[{tipo: "Importacion",nombre: "Importaciones"},
                            {tipo: "Exportacion",nombre: "Exportaciones"}
            ],            
            perfiles: [0],
            model: {
                id: "",
                nombre: "",                
                tipo: "",
                prefijo: "",
                usuario: "",
                rfc: "",
                opciones: {},                         
            },
            opciones: {
                    tipo_operacion: "",
                    clave_pedimento: [],
                    patente: [],
                    aduana: [],
                    usuario: "",
                    metadato: "",
                    tipos_documento: ["P030","P031"],
                },
            rules: {
                required: v => !!v || "Este campo es requerido",                
            },
            
            datos:[],            
            permisos_perfiles: [],
            permisos: {
                headers: [{
                        text: "Categoría",
                        value: "categoria"
                    },
                    {
                        text: "Permiso",
                        value: "nombre"
                    }
                ]
            },                         
            tiposDocumentos: {  
                items:[],     
                columns:['id','clave','descripcion'],
                options:{
                    filterable: ["clave", "descripcion"],
                    sortable: ["clave", "descripcion"],
                    orderBy: {
                        column: 'clave',
                        ascending: true
                    },
                    headings: {
                        id: "",
                        clave: "Clave",
                        descripcion: "Descripción",                        
                        actions: "Descargar"
                    } ,                    
                },
                filtrados:[],
                columnsFiltrados:['clave','descripcion'],
                optionsFiltrados:{
                    filterable: ["clave", "descripcion"],
                    sortable: ["clave", "descripcion"],
                    orderBy: {
                        column: 'clave',
                        ascending: true
                    },
                    headings: {                        
                        clave: "Clave",
                        descripcion: "Descripción",                                                
                    } ,                    
                }            
            }                     
        };
    },
    created: function () {  
        this.id_cliente = this.$local_storage.get("id_cliente");      
        this.getAduanas();
        this.getPatentes();
        this.getClaves();
        this.getTiposDocumentos();        
        this.cargar();        
    },
    methods: {
        getNombreTipo:function(val){
            return val.nombre+ " ("+val.prefijo+")";
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        check_all: function() {
            let arr = this.allChecked ? this.tiposDocumentos.items.map(row => row.clave) : [];
            if (arr.length == 0) {
                this.opciones.tipos_documento = [];
            } else {
                for (var i = 0; i < arr.length; i++) {
                    if (this.opciones.tipos_documento.includes(arr[i])) {
                        continue;
                    } else {
                        this.opciones.tipos_documento.push(arr[i]);
                    }
                }
            }
        },
        clearOpciones: function(){
            if(this.model.tipo!=undefined){
                if(this.model.tipo=="Expediente"){
                   this.opciones.usuario = "";
                   this.opciones.metadato = ""; 
                } else if(this.model.tipo=="AgenciaAduanal"){
                   this.opciones.clave_pedimento = [];
                   this.opciones.tipo_operacion = ""; 
                }
            }
            
        },
        getAduanas:function(){
            var data = {
                rfc: this.$local_storage.get("rfc"),
            };
            axios.post(this.$hostname + "reportes/get_aduanas/", data)            
            .then(response => {
                if(response.data!=undefined){
                    this.aduanasArr = response.data;                    
                }                
            })
            .catch(error => {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener las aduanas.",
                    footer: ""
                });
            });
        },
        getPatentes:function(){
            var data = {
                cliente: this.id_cliente,                
            };
            //PATENTES
            axios.post(this.$hostname + "reportes/get_patentes/", {rfc: this.$local_storage.get("rfc")})
            .then(response => {
                if(response.data!=undefined){
                    this.patentesArr = response.data;
                }                
            })
            .catch(error => {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener las patentes.",
                    footer: ""
                });
            });                               
        },                
        getClaves:function(){
            var data = {
                tabla: 13,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
            .then(response => {
                if(response.data!=undefined){
                    this.clavesPedimentos = response.data;                    
                }                
            })
            .catch(error => {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener las claves de pedimentos.",
                    footer: ""
                });
            });
        },
        getTiposDocumentos: function(){
            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
            .then(response => {
                if(response.data!=undefined){
                    this.tiposDocumentos.items = response.data;                    
                }                
            })
            .catch(error => {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los tipos de documento.",
                    footer: ""
                });
            });
        },         
        openModal: function (type) {
            if (type === 1) {
                this.update = false;
                this.limpiarModel();
            } else {
                this.update = true;
            }       
            this.limpiaFiltros("vuetabletipos");            
            this.allChecked = false;
            this.modal = true;
                
        },
        limpiaFiltros(vuetableOpc){
            if(this.$refs[vuetableOpc]!=undefined){ //Limpiamos los filtros
                if(this.$refs[vuetableOpc].query!=undefined){
                    var el = document.getElementsByName("vf__descripcion");
                    var ele = document.getElementsByName("vf__clave");
                    for(var k in el){
                        try {
                            el[k].value="";    
                        } catch (error) {}                                                
                    }
                    for(var k in ele){
                        try {
                            ele[k].value="";    
                        } catch (error) {}                                                
                    }                    
                    this.$refs[vuetableOpc].query.descripcion = "";
                    this.$refs[vuetableOpc].query.clave = "";
                }                                    
            }
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            for (var k in this.opciones) {
                if(k!="tipos_documento")
                    this.opciones[k] = "";
                else 
                    this.opciones[k] = [];
            }            
        },
        openModalDetalle: function (id) {                        
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "catalogos/configurables/" + id + "/")                
                .then(response => {
                    this.model = response.data;
                    this.opciones = JSON.parse(this.model.opciones);                 
                    this.tiposDocumentos.filtrados = this.getTiposFiltrados(this.opciones.tipos_documento);
                    this.titleModalDetalle = this.model.prefijo+"_"+this.model.nombre; 
                    this.limpiaFiltros("vuetabletiposfiltrados");                    
                    this.modal_detalle=true;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el detalle del configurable. Favor de comunicarse con soporte.",
                        footer: ""
                    });
                });            
        },
                       
        getTiposFiltrados: function (arr) {
            try {                
                var filtro = this.tiposDocumentos.items
                    .filter(function (ele) {
                        return arr.includes(ele.clave);
                    });                
                return filtro;
            } catch (error) {
                console.log("Error",error);
                return [];                
            }            
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get("rfc"),
            };            
            axios
                .post(this.$hostname + "catalogos/configurables/get_configurables/", data)                
                .then(response => {
                    this.datos = response.data;    
                    for (var k in this.datos) {
                        this.datos[k].created_at = this.parseDate(this.datos[k].created_at);
                        this.datos[k].tipo = this.getTipo(this.datos[k].tipo);
                    }                
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        getTipo(tipo){
            var filtro = this.tipos.filter( e => {return e.tipo == tipo});
            if(filtro.length >0)
                return filtro[0].nombre;
            else 
                return "";
        },               
        getConfigurable: function (id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "catalogos/configurables/" + id + "/")                
                .then(response => {
                    this.model = response.data;
                    this.opciones = JSON.parse(this.model.opciones);                                        
                    this.$root.$dialogLoader.hide();
                    this.openModal(2);
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el configurable",
                        footer: ""
                    });
                });
        },
        getPrefijo: function(tipo){
            var filtro = this.tipos.filter(function(e){
                return e.tipo == tipo;
            });
            if (filtro.length>0)
                return filtro[0].prefijo;
            else 
                return '';
        },
        save: function () {  
            if(this.opciones.tipos_documento.length<=0){
                this.$swal({
                    type: "info",
                    title: "¡Importante!",
                    text: "Debe seleccionar al menos un tipo de documento",
                    footer: ""
                });
            } else if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');    
                this.model.prefijo = this.getPrefijo(this.model.tipo);
                let data = this.model;                
                data["opciones"] = JSON.stringify(this.opciones);                
                data["rfc"] = this.$local_storage.get("rfc");
                data["usuario"] = this.$local_storage.get("email");
                //console.log(data);   
                
                axios
                    .post(this.$hostname + "catalogos/configurables/", data)                    
                    .then(response => {
                        this.modal = false;
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se guardó correctamente.",
                            footer: ""
                        });
                        this.cargar();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos. Favor de comunicarse con soporte.",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        updateConfigurable: function () {                        
            if(this.opciones.tipos_documento.length<=0){
                this.$swal({
                    type: "info",
                    title: "¡Importante!",
                    text: "Debe seleccionar al menos un tipo de documento",
                    footer: ""
                });
            } else if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                
                this.model.prefijo = this.getPrefijo(this.model.tipo);
                let data = this.model;                
                data["opciones"] = JSON.stringify(this.opciones);                
                axios
                    .put(this.$hostname + "catalogos/configurables/" + this.model.id + "/", data)                    
                    .then(response => {
                        this.modal = false;
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se guardó correctamente.",
                            footer: ""
                        });
                        this.cargar();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al actualizar los datos. Favor de comunicarse con soporte.",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        eliminar: function (id) {            
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');  
                    axios
                    .delete(this.$hostname + "catalogos/configurables/" + id + "/")                    
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                        this.cargar();
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                            footer: ""
                        });
                    });   
                }
                    
            });
        },        
    }
};
</script>
<style scoped>
.elevation-2 >>> #VueTables_th--id {
  width: 10% !important;  
}
.elevation-2 >>> #VueTables_th--clave {
  width: 20% !important;  
}
.elevation-2 >>> #VueTables_th--descripcion {
  width: 70% !important;
}
.negrita {
  font-weight:bold;
}
</style>
